// src/index.js - ROUTING AVEC ANALYTICS (SANS STRICTMODE)

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';

// Composants
import App from './App';
import BlogArticle from './BlogArticle';
import News from './News';
import BlogBackoffice from './BlogBackoffice';
import Login from './Login';

// Analytics
import AnalyticsTracker from './components/Analytics/AnalyticsTracker';
import AnalyticsConsent from './components/Analytics/AnalyticsConsent';

// Composant de protection des routes
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = window.Laravel?.user !== null;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // ⚠️ STRICTMODE DÉSACTIVÉ pour éviter les doubles montages en dev
  // React.StrictMode monte/démonte les composants 2x en développement
  // ce qui déclenche les analytics 2x
  <BrowserRouter>
    {/* Bannière de consentement RGPD */}
  

    {/*
      ✅ TRACKER ANALYTICS UNIQUE
      Placé une seule fois au niveau racine
      Se déclenche automatiquement à chaque changement de route
    */}


    <Routes>
      {/* Page d'accueil */}
      <Route path="/" element={<App />} />

      {/* Version française */}
      <Route path="/fr" element={<App defaultLang="fr" />} />

      {/* Routes News/Blog */}
      <Route path="/news" element={<News />} />
      <Route path="/news/:id" element={<BlogArticle />} />

      {/* Login */}
      <Route path="/login" element={<Login />} />

      {/* Backoffice protégé */}
      <Route
        path="/addadmin/*"
        element={
          <ProtectedRoute>
            <BlogBackoffice />
          </ProtectedRoute>
        }
      />

      {/* Redirection par défaut */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);
